export default "__VITE_ASSET__OU7Zf84z__"